export default __webpack_public_path__ + "static/media/AE_Logo.26c95768.png";